<template>
  <section-page
    :title="'Active Users (' + activeUsers.length + '/' + userLimit + ')'"
    is-short
  >
    <app-loading-section
      :loading="false"
      :count="activeUsers.length"
      heading="There are no active users"
    >
      <table-default
        :table-data="activeUsers"
        default-sort="full_name"
      >
        <b-table-column label="Name" field="full_name" sortable v-slot="props">
          {{ props.row.full_name }}
          <span class="text-sub-label" v-if="props.row.is_owner">(Owner)</span>
        </b-table-column>

        <b-table-column label="Email Address" field="email_address" sortable v-slot="props">
          {{ props.row.email_address }}
        </b-table-column>

        <b-table-column label="Added On" field="created_at" sortable v-slot="props">
          {{ formatDate(props.row.created_at) }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="200" v-slot="props">
          <button-link @click="handleManageUser(props.row)">Manage</button-link>
          <button-link @click="$refs.deactivateModal.open(props.row)" v-if="! props.row.is_owner">Deactivate</button-link>
        </b-table-column>
      </table-default>
    </app-loading-section>

    <modal-container>
      <modal-form-edit
        ref="manageActiveUserForm"
        title="Manage User"
        form-component="user-form"
        hide-delete-button
      >
        <user-permissions :user="selectedUser"/>
      </modal-form-edit>
    </modal-container>

    <deactivate-user-modal
      ref="deactivateModal"
    ></deactivate-user-modal>
  </section-page>
</template>

<script>
import DeactivateUserModal from './DeactivateUserModal';
import dates from "../../../services/dates";
import UserPermissions from "./UserPermissions.vue";

export default {
  name: "UsersActiveUsers",
  components: {
    UserPermissions,
    DeactivateUserModal
  },
  data() {
    return {
      selectedUser: {}
    }
  },
  computed: {
    activeUsers() {
      return this.$store.getters.activeUsers;
    },
    userLimit() {
      return this.$store.getters.account.user_limit;
    }
  },
  methods: {
    formatDate(timestamp) {
      return dates.formatAsDate(timestamp);
    },
    handleManageUser(user) {
      this.selectedUser = user
      console.log('User: ', user);
      this.$refs.manageActiveUserForm.open(user)
    }
  },
}
</script>

<style scoped>

</style>
